const RouteImages = (props) => {
  return <div></div>;
};

export default RouteImages;
